import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteIntegration($companyId: ID!, $id: ID!) {
    deleteIntegration(companyId: $companyId, id: $id) {
      integration {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
